"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListHeaderLink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ListHeaderLink = styled_components_1.default.h3 `
  font-size: 14px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 5px;
`;
//# sourceMappingURL=list-header-link.js.map